/// <reference path="../../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    import IUser = Models.IUser;
    import Vno = Models.Vno;

    export interface IUserNewModalScope extends ng.IScope {
        title: string;
        user: IUser;
        confirmedPassword: string;
        modalClose: () => void;
        modalSave: () => void;
        onPasswordChanged: () => void;
        onUserNameChanged: () => void;
        onEmailChanged: () => void;
        vnos: Vno[];
        selectedVno: {
            vno: Models.Vno
        };
        passwordHidden: boolean;
        confirmPasswordHidden: boolean;
        lastUserName: string;
        lastEmail: string;
        userNameAlreadyExists: boolean;
        emailAlreadyExists: boolean;
        togglePasswordVisibility: () => void;
        toggleConfirmPasswordVisibility: () => void;
    }

    export interface IUserEditResponse {
        user: IUser;
        selectedVno: {
            vno: Models.Vno
        };
    }

    export class UserNewEditModalController {
        public static templateURL: string = "decorators/modals/user-new-edit-modal.html";
        public static ID: string = "#user-new-edit-modal";
        public static $name: string = "userNewEditModalController";
        public static $inject: string[] = ['$scope', 'close', '$timeout', 'title', 'user', 'vnos', 'userService'];
        private $scope: IUserNewModalScope;
        private close: (parameters: IUserEditResponse) => void;

        private passwordChanged: boolean = false;
        private initialUsername: string = undefined;
        private initialEmail: string = undefined;

        private userService: Services.UserService;

        /**
         * Constructor
         */
        constructor($scope: IUserNewModalScope,
                    close: (parameters: IUserEditResponse) => void,
                    $timeout: ng.ITimeoutService,
                    title: string,
                    user: IUser,
                    vnos: Vno[],
                    userService: Services.UserService,
        ) {
            $timeout(() => {
                window.altair_forms_validation();
            }, 500);
            this.$scope = $scope;
            this.userService = userService;
            this.close = close;
            this.$scope.title = title;
            this.$scope.user = user;
            this.initialUsername = this.$scope.user.username;
            this.initialEmail = this.$scope.user.email;
            this.$scope.confirmedPassword = this.$scope.user.password;
            this.$scope.vnos = vnos;
            this.$scope.selectedVno = { vno: vnos ? vnos[0] : undefined };
            this.$scope.passwordHidden = true;
            this.$scope.lastUserName = "";
            this.$scope.lastEmail = "";
            this.$scope.userNameAlreadyExists = false;
            this.$scope.emailAlreadyExists = false;
            this.$scope.togglePasswordVisibility = (): void => {
                this.$scope.passwordHidden = !this.$scope.passwordHidden;
            };

            this.$scope.confirmPasswordHidden = true;

            this.$scope.toggleConfirmPasswordVisibility = (): void => {
                this.$scope.confirmPasswordHidden = !this.$scope.confirmPasswordHidden;
            };

            this.$scope.modalClose = (): void => {
                this.close(undefined);
            };

            this.$scope.modalSave = async (): Promise<void> => {
                if (this.$scope.user.username !== this.initialUsername) {
                    this.$scope.userNameAlreadyExists = await this.validateUserNameOrEmail(this.$scope.user.username);
                }
                if (this.$scope.user.email !== this.initialEmail) {
                    this.$scope.emailAlreadyExists =  await this.validateUserNameOrEmail(this.$scope.user.email);
                }
                this.$scope.lastUserName = this.$scope.user.username;
                this.$scope.lastEmail = this.$scope.user.email;
                if (this.$scope.userNameAlreadyExists && this.$scope.user.username && this.$scope.user.username !== '' &&
                    this.$scope.user.username !== this.initialUsername) {
                    let element: JQuery = $("input[name=username]");
                    let errorMessage: string = "Username already in use as Email or Username."
                    this.addErrorClass(errorMessage, element);
                }
                if (this.$scope.emailAlreadyExists && this.$scope.user.email && this.$scope.user.email !== '' &&
                    this.$scope.user.email !== this.initialEmail) {
                    let element: JQuery = $("input[name=email]");
                    let errorMessage: string = "Email already in use as Email or Username."
                    this.addErrorClass(errorMessage, element);
                }
                if (this.$scope.user.fullname && this.$scope.user.fullname !== '' &&
                    this.$scope.user.username && this.$scope.user.username !== '' &&
                    this.$scope.user.email && this.$scope.user.email !== '' &&
                    this.validatePassword() && !this.$scope.userNameAlreadyExists && !this.$scope.emailAlreadyExists) {
                    let result: IUserEditResponse = {
                        user: this.$scope.user,
                        selectedVno: this.$scope.selectedVno,
                    };
                    this.close(result);
                }
            };

            this.$scope.onUserNameChanged = (): void => {
                if (((this.$scope.user.username === "" && this.$scope.user.username !== undefined) ||
                    this.$scope.user.username !== this.$scope.lastUserName) &&
                    this.$scope.userNameAlreadyExists) {
                    this.$scope.userNameAlreadyExists = false;
                    let element: JQuery = $("input[name=username]");
                    this.removeErrorClass(element);
;
                }
            };

            this.$scope.onEmailChanged = (): void => {
                if (((this.$scope.user.email === "" && this.$scope.user.email !== undefined) ||
                    this.$scope.user.email !== this.$scope.lastEmail) &&
                    this.$scope.emailAlreadyExists) {
                    this.$scope.emailAlreadyExists = false;
                    let element: JQuery = $("input[name=email]");
                    this.removeErrorClass(element);
                }
            };

            this.$scope.onPasswordChanged = (): void => {
                this.passwordChanged = true;

            };

        }

        public addErrorClass(errorMessage: string, element: JQuery): void {
            if (!element.hasClass('md-input-wrapper-danger')) {
                element.addClass('md-input-wrapper-danger');
                element.parent().append(
                    `<div class="parsley-errors-list filled custom-type-error" id="parsley-id-1432">
                        <span class="parsley-required">` + errorMessage + `</span>
                        </div>`,
                );
                element.attr('data-parsley-id', "1432");
                element.addClass('md-input-danger"');
            }
        }

        public removeErrorClass(element: JQuery): void {
            element.removeClass('md-input-wrapper-danger');
            element.next().remove();
            element.removeClass('md-input-danger');
            element.removeAttr('data-parsley-id');
        }
        public isEditMode(): boolean {
            return this.$scope.title.toLowerCase() === 'edit user';
        }

        private async validateUserNameOrEmail(userNameOrEmail: string): Promise<boolean> {
            let userNameOrEmailExists: boolean = false;
            console.log("test");
            if (userNameOrEmail !== undefined) {
                await this.userService.findByUsername(userNameOrEmail).then((response: IUser) => {
                    if (response) {
                        userNameOrEmailExists = true;
                    }
                }).catch(() => {
                    userNameOrEmailExists = false;
                });
            }
            if (userNameOrEmail !== undefined && !userNameOrEmailExists) {
                await this.userService.findByEmail(userNameOrEmail).then((response: IUser) => {
                    if (response) {
                        userNameOrEmailExists = true;
                    }
                }).catch(() => {
                    userNameOrEmailExists = false;
                });
            }
            return userNameOrEmailExists;
        }

        private validatePassword(): boolean {
            const passwordNotEmpty: boolean = this.$scope.user.password && this.$scope.user.password !== '';
            const confirmedPasswordNotEmpty: boolean = this.$scope.confirmedPassword  && this.$scope.confirmedPassword  !== '';
            const passwordsMatch: boolean = this.$scope.user.password === this.$scope.confirmedPassword;

            if ((!this.isEditMode()) || (this.isEditMode() && this.passwordChanged)) {
                return passwordNotEmpty && confirmedPasswordNotEmpty && passwordsMatch;
            } else {
                return true;
            }

        }

    }
}